module.exports = __webpack_public_path__ + "assets/img/flicker.98af40bd.png";